import { FormikProvider } from 'formik';
import PayeeSelector from '@shared/components/PayeeSelector';
import ActionButton from '@shared/components/Buttons/ActionButton';

const PayeeAndConfirm = ({
  formik,
  isLoadingPay,
  payee,
  paymentSelectorRef,
  formikPaymentRef,
}) => {
  const handleConfirm = async () => {
    if (isLoadingPay) return;

    const isPaymentValid = paymentSelectorRef?.current?.validatePayment?.();
    if (!isPaymentValid) return;

    if (formikPaymentRef?.current) {
      await formikPaymentRef.current.submitForm();
    }

    formik.submitForm();
  };

  return (
    <FormikProvider value={formik}>
      <form
        onSubmit={formik.handleSubmit}
        autoComplete="off"
        style={{ width: '100%' }}
      >
        <PayeeSelector payee={payee} formik={formik} />
        <ActionButton
          isLoading={isLoadingPay}
          align="end"
          onClick={handleConfirm}
        />
      </form>
    </FormikProvider>
  );
};

export default PayeeAndConfirm;
